<template>
  <div class="base" style="width: 100%; height: 100%">
    <transition name="el-fade-in-linear">
      <div class="whole_wrap" v-show="show.wholeShow">
        <div class="head_wrap">
          <el-image :src="require('@/assets/images/cover.png')"
            ><template #error>
              <div class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div> </template
          ></el-image>
        </div>
        <div class="body_wrap">
          <div class="tips_content">
            <p
              style="
                float: left;
                font-size: 13px;
                color: #67c23a;
                padding-bottom: 3px;
              "
            >
              {{
                $t("bigfive.toptext_1") +
                _pages.results.length +
                $t("text.record")
              }}
            </p>
          </div>
          <div class="results_content" v-loading="_pages.tableLoading">
            <div v-if="_pages.results.length > 0">
              <el-table
                :data="
                  _pages.results.slice(
                    (_pages.pagination.currentPage - 1) * 15,
                    _pages.pagination.currentPage * 15
                  )
                "
                stripe
                border
                :header-cell-style="{
                  textAlign: 'center',
                  backgroundColor: '#dcdfe6',
                }"
                :cell-style="{ textAlign: 'center' }"
                :default-sort="{ prop: 'created_time', order: 'descending' }"
              >
                <el-table-column :label="$t('bigfiveresults.survey_name')">
                  <template #default="scope">
                    {{ scope.row.name }}
                  </template>
                </el-table-column>

                <el-table-column :label="$t('bigfiveresults.survey_post')">
                  <template #default="scope">
                    {{ scope.row.post }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('bigfiveresults.survey_time')"
                  prop="created_time"
                  sortable
                >
                  <template #default="scope">
                    {{ scope.row.created_time }}
                  </template>
                </el-table-column>

                <el-table-column :label="$t('iqresults.duration')">
                  <template #default="scope">
                    <span v-if="scope.row.duration > 60"
                      >{{ parseInt(scope.row.duration / 60)
                      }}{{ $t("text.minute") }}{{ scope.row.duration % 60
                      }}{{ $t("text.second") }}</span
                    >
                    <span v-else
                      >{{ scope.row.duration }}{{ $t("text.second") }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column :label="$t('iqresults.score')">
                  <template #default="scope">
                    {{ scope.row.score }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('iqresults.label_match_post')"
                  :width="350"
                >
                  <template #default="scope">
                    <el-select
                      v-model="_pages.mathList[scope.$index]"
                      filterable
                      size="small"
                      :placeholder="$t('text.placeholder_select')"
                      style="width: 30vh"
                      @change="
                        updateInformation(
                          scope.row,
                          _pages.mathList[scope.$index],
                          scope.$index
                        )
                      "
                    >
                      <el-option
                        v-for="(item, index) in _pages.standard"
                        :key="index"
                        :label="item.posts"
                        :value="
                          item.id +
                          '-' +
                          item.minimum +
                          '-' +
                          item.maximum +
                          '-' +
                          item.threshold
                        "
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('iqresults.label_standard_score_range')"
                >
                  <template #default="scope">
                    {{ scope.row.range }}
                  </template>
                </el-table-column>

                <el-table-column :label="$t('iqresults.label_anal_result')">
                  <template #default="scope">
                    <span :id="'rs_expain__' + scope.$index">{{
                      scope.row.explains
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('question.label_options')">
                  <template #default="scope">
                    <el-button
                      @click="removeRecord(scope.row)"
                      type="danger"
                      circle
                      size="small"
                      class="el-icon-delete"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="_tb_pagination">
                <el-pagination
                  background
                  @current-change="paginationCurrentChange"
                  :page-size="15"
                  :current-page="_pages.pagination.currentPage"
                  layout="prev, pager, next"
                  :total="_pages.results.length"
                />
              </div>
            </div>
            <div v-else>
              <el-empty
                :description="$t('bigfiveresults.empty_results_discription')"
                :image-size="300"
              >
                <el-button type="success" @click="reload" size="small">{{
                  $t("text.btn_refresh")
                }}</el-button>
              </el-empty>
            </div>
          </div>
        </div>
        <div class="foot_wrap"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as utilsjs from '@/assets/js/utils'
import * as mountederjs from '@/assets/js/mounteder'
export default {
  data() {
    return {
      show: {
        wholeShow: false
      },
      _pages: {
        username: '',
        userinfo: {},
        lang: '',
        results: [],
        standard: [],
        resultActiveNames: [],
        mathList: [],
        tableLoading: true,
        pagination: {
          currentPage: 1
        }
      },
      _forms: {

      }
    };
  },
  mounted() {
    this.$i18n.locale = 'ch';
    document.title = this.$t('title.iq_results');
    sessionStorage.setItem('lang', this.$i18n.locale);
    this._pages.lang = sessionStorage.getItem('lang');

    this.queryStandard();
    this.queryResults();

    setTimeout(() => { this.show.wholeShow = true }, 1);

  },
  methods: {
    reload() {
      location.reload();
    },
    queryStandard() {
      this.$axios({
        method: 'post',
        url: this.$api + '/api/survey/queryIqStandard'
      }).then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            this._pages.standard = response.data.data;

            return;
          } else if (response.data.code == '210') {
            this.$notify.warning({
              title: this.$t("notify.title_notification"),
              message: this.$t('notify.result_null')
            });

            return;
          } else {
            
            this.$notify.error({
              title: this.$t("notify.title_server"),
              message: this.$t('notify.content_refused')
            });
            return;
          }
        } else {
          this.$notify.error({
            title: this.$t('notify.title_server'),
            message: this.$t('notify.content_server') + response.status
          });
          return;
        }
      }).catch((error) => {
        this.$notify.error({
          title: this.$t("notify.title_server"),
          message: this.$t('notify.content_refused')
        });
        return;
      });
    },
    queryResults() {
      this.$axios({
        method: 'post',
        url: this.$api + '/api/survey/queryIqResults'
      }).then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            this._pages.results = response.data.data;

            return;
          } else if (response.data.code == '210') {
            this.$notify.warning({
              title: this.$t("notify.title_notification"),
              message: this.$t('notify.result_null')
            });

            return;
          } else {
            
            this.$notify.error({
              title: this.$t("notify.title_server"),
              message: this.$t('notify.content_refused')
            });
            return;
          }
        } else {
          this.$notify.error({
            title: this.$t('notify.title_server'),
            message: this.$t('notify.content_server') + response.status
          });
          return;
        }
      }).catch((error) => {
        this.$notify.error({
          title: this.$t("notify.title_server"),
          message: this.$t('notify.content_refused')
        });
        return;
      });
      this._pages.tableLoading = false;
    },
    updateInformation(result, rangeVal, index) {
      result.range = rangeVal.split('-')[1] + '~' + rangeVal.split('-')[2];
      if (result.score < rangeVal.split('-')[3]) {
        result.explains = this.$t("iqresults.text_lower");
        document.getElementById('rs_expain__' + index).style.color = '#f56c6c';
      } else if (rangeVal.split('-')[3] <= result.score && result.score < rangeVal.split('-')[1]) {
        result.explains = this.$t("iqresults.text_slightly_lower");
        document.getElementById('rs_expain__' + index).style.color = '#e6a23c';
      } else if (rangeVal.split('-')[1] <= result.score && result.score <= rangeVal.split('-')[2]) {
        result.explains = this.$t("iqresults.text_normal");
        document.getElementById('rs_expain__' + index).style.color = '#409eff';
      } else if (result.score > rangeVal.split('-')[2]) {
        result.explains = this.$t("iqresults.text_higher");
        document.getElementById('rs_expain__' + index).style.color = 'rgba(30, 215, 95, 1)';
      }
    },
    removeRecord(record) {
      this.$axios({
        method: 'post',
        url: this.$api + '/api/survey/removeIqRecord',
        data: record
      }).then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            this.queryResults();

            return;
          } else {
            
            this.$notify.error({
              title: this.$t("notify.title_server"),
              message: this.$t('notify.content_refused')
            });
            return;
          }
        } else {
          this.$notify.error({
            title: this.$t('notify.title_server'),
            message: this.$t('notify.content_server') + response.status
          });
          return;
        }
      }).catch((error) => {
        this.$notify.error({
          title: this.$t("notify.title_server"),
          message: this.$t('notify.content_refused')
        });
        return;
      });
    },
    paginationCurrentChange(currentPage) {
      
      this._pages.pagination.currentPage = currentPage;
    },
  }
}
</script>

<style scoped lang="scss">
.head_wrap h1 {
  margin-top: 5vh;
}
.head_wrap .el-image {
  width: 12vh;
  float: left;
  padding-left: 2vw;
}
.body_wrap {
  padding-top: 7vh;
  width: 100%;
}
.tips_content {
  width: 80%;
  margin: 0 auto;
}
.results_content {
  width: 80%;
  margin: 0 auto;
}
.results_content p {
  text-align: left;
  font-size: 17px;
  line-height: 35px;
  font-family: "Microsoft YaHei", "微软雅黑";
}
._tb_pagination {
  position: fixed;
  bottom: 3vh;
  right: 10vw;
}
</style>